<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>Trabajadores de obra</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono trabajadores"
              :src="imgServer+'apps/myfrac/admin/assets/Trabajadores@3x.png'"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{headerTitle}}
          <div class="text-right" style=" margin-top: -10px; margin-right: -20px; float: right;">
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Descartar registro</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="remove"
              >
                <mdb-icon icon="times" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>

        <!--/Card image-->

        <!--Card content-->
        <mdb-card-body>
          <form id="formWorkers" class="needs-validation" novalidate @submit="checkFormWorker">
            <mdb-container>
              <mdb-row>
                <div>
                  <span style="font-family: OpenSans-Bold; font-size: 14px;">Datos del registro</span>
                </div>
              </mdb-row>
              <mdb-row style="margin-top: 2rem;">
                <mdb-col md="4">
                  <div style="margin-left: 3rem; width: 42%;">
                    <div >
                      <my-upload
                        field="img"
                        @crop-success="cropSuccess"
                        :width="100"
                        :height="100"
                        v-model="showImgW"
                        img-format="png"
                        langType="es-MX"
                        :noSquare="true"
                      ></my-upload>
                    </div>
                    <div @click="toggleWorkers">
                      <mdb-avatar class="avatar-width style_avatar">
                        <img alt="imagen del trabajador" :src="urlAvatar" id="avatar" class="rounded-circle btncapturar" />
                      </mdb-avatar>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col md="4">
                  <mdb-row>
                    <div class="form-group" style="width: 80%">
                      <label
                        for="firtsName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="firstName"
                        required
                        placeholder="Nombre"
                        maxlength="64"
                        v-model="form.firstName"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-row>
                  <mdb-row>
                    <div class="form-group" style="width: 80%">
                      <label
                        for="lastName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Apellidos</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="lastName"
                        required
                        placeholder="Apellidos"
                        maxlength="64"
                        v-model="form.lastName"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-row>
                </mdb-col>
                <mdb-col md="4">
                  <mdb-row>
                    <div class="form-group" style="width: 80%">
                      <label
                        for="constructionPlace"
                        style="font-family: OpenSans-Semibold;"
                      >Asignar obra</label>
                      <model-select
                        :options="constructions"
                        class="text-input"
                        v-model="constructionModel"
                        v-bind:style="{height: '37px', marginTop: '10px', fontSize: '12px'}"
                        placeholder="Selecciona una obra"
                        :isError="placeValid"
                        :isDisabled="isdisable"
                      ></model-select>
                    </div>
                  </mdb-row>
                  <mdb-row>
                    <div></div>
                  </mdb-row>
                </mdb-col>
              </mdb-row>
              <mdb-row style="margin-top: 4rem;">
                <mdb-col md="5" style="margin-left:50px; margin-right: 30px">
                  <div v-if="!fileId">
                    <div
                      class="row center-align"
                      style="margin-bottom: 10px; margin-left: 6rem;"
                    >Identificación oficial</div>
                    <div class="row">
                      <div id="formId" class="form-csv">
                        <form enctype="multipart/form-data" id="fileUploadForm">
                          <input
                            id="idOficial"
                            name="idOficial"
                            type="file"
                            accept="image/jpeg, image/png, application/pdf"
                            ref="fileupload"
                            @change="uploadId"
                          />
                          <div
                            id="csv-success"
                            class="center-align ml-3 mr-3"
                            style="font-size: 12px; text-align: center; margin-top: 15%; color: #a09c9c;"
                          >
                            <i
                              class="far fa-copy"
                              style="padding: 15px 10px; font-size: 30px; color: #e8e9ec;"
                            ></i>
                            <br />Arrastra tu archivo aquí o
                            <u style="color:blue;">
                              <span style="color:blue;">adjúntalo desde tu computadora</span>
                            </u>
                          </div>
                          <h6 id="csv-failed" class="center-align" style="display: none">
                            <u style="color:red;">
                              <span style="color:red;">Intenta de nuevo</span>
                            </u>
                          </h6>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div v-if="fileId">
                    <mdb-row>
                      <div>
                        <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Eliminar archivo</span>
                          <mdb-btn
                            slot="reference"
                            type="button"
                            rounded
                            size="sm"
                            class="px-2 btn_background"
                            @click="removeId"
                          >
                            <mdb-icon icon="times" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
                        <iframe title="identificacion oficial" class="embed-responsive-item" :src="file_url" allowfullscreen></iframe>
                      </div>
                    </mdb-row>
                  </div>
                </mdb-col>
                <mdb-col md="5" style="margin-right:50px; margin-left: 30px">
                  <div v-if="!file">
                    <div
                      class="row center-align"
                      style="margin-bottom: 10px; margin-left: 6rem;"
                    >Comprobante de domicilio</div>
                    <div class="row">
                      <div id="formReceipt" class="form-csv">
                        <form enctype="multipart/form-data" id="fileUpload">
                          <input
                            id="comprobante"
                            name="comprobante"
                            type="file"
                            accept="image/jpeg, image/png, application/pdf"
                            ref="fileupload2"
                            @change="signalChange"
                          />
                          <div
                            id="csv-success"
                            class="center-align ml-3 mr-3"
                            style="font-size: 12px; text-align: center; margin-top: 15%; color: #a09c9c;"
                          >
                            <i
                              class="far fa-copy"
                              style="padding: 15px 10px; font-size: 30px; color: #e8e9ec;"
                            ></i>
                            <br />Arrastra la foto aquí o
                            <u style="color:blue;">
                              <span style="color:blue;">adjúntala desde tu computadora</span>
                            </u>
                          </div>
                          <h6 id="csv-failed" class="center-align" style="display: none">
                            <u style="color:red;">
                              <span style="color:red;">Intenta de nuevo</span>
                            </u>
                          </h6>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div v-if="file">
                    <mdb-row>
                      <div>
                        <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Eliminar archivo</span>
                          <mdb-btn
                            slot="reference"
                            type="button"
                            rounded
                            size="sm"
                            class="px-2 btn_background"
                            @click="removeCom"
                          >
                            <mdb-icon icon="times" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
                        <iframe title="comprobante de domicilio" class="embed-responsive-item" :src="file_url2" allowfullscreen></iframe>
                      </div>
                    </mdb-row>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-row style="padding-left: 35%; padding-top: 2%;">
                <mdb-col md="2" style="margin-right: 2rem;">
                  <button
                    type="button"
                    class="waves-effect waves-dark btn btn-next btn-color-prev"
                    @click="remove()"
                  >Cancelar</button>
                </mdb-col>
                <mdb-col md="2" style="margin-left: 2rem;">
                  <mdb-btn
                    v-show="!isLoading"
                    type="submit"
                    class="waves-effect waves-dark btn btn-next btn-color-next"
                  >{{buttonTitle}}</mdb-btn>
                  <mdb-btn
                    v-show="isLoading"
                    type="submit"
                    class="waves-effect waves-dark btn btn-next btn-color-next"
                  disabled>
                    <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                  </mdb-btn>
                </mdb-col>
                <!--Buttons content-->
              </mdb-row>
            </mdb-container>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import * as firebase from 'firebase/app'
import 'firebase/database'
import myUpload from "vue-image-crop-upload";
import { ModelSelect } from "vue-search-select";
import {
  mdbContainer,
  mdbStepper,
  mdbTooltip,
  mdbStep,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn,
  mdbDatePicker,
  mdbTimePicker,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbFileInput,
  mdbAvatar,
  mdbSelect,
  mdbFormInline
} from "mdbvue";

export default {
  name: "Stepper",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbStepper,
    mdbStep,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbDatePicker,
    mdbTimePicker,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbFileInput,
    mdbSelect,
    mdbFormInline,
    ModelSelect,
    "my-upload": myUpload
    //vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dataBase: null,
      isLoading: false,
      headerTitle: "Registrar trabajador",
      buttonTitle: "Registrar",
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      urlAvatar:
        Servers.serverImg + "apps/myfrac/admin/assets/btncapturar.png",
      profileFile: null,
      extension2: "",
      showImgW: false,
      avatarImg: false,
      constructions: [],
      file: false,
      file_url2: "",
      fileId: false,
      file_url: "",
      fileIdForm: {
        name: "",
        extension: "",
        mimeType: "",
        content: ""
      },
      fileComproForm: {
        name: "",
        extension: "",
        mimeType: "",
        content: ""
      },
      fileAvatarForm: {
        name: "",
        extension: "",
        mimeType: "",
        content: ""
      },
      form: {
        uuid: "",
        firstName: "",
        lastName: ""
      },
      constructionModel: {
        uuid: "",
        value: ""
      },
      placeValid: false,
      isdisable: false
    }; // END RETURN
  },
  methods: {
    removeCom() {
      this.file = false;
      this.file_url2 = "";
      this.fileComproForm = {
        name: "",
        extension: "",
        mimeType: "",
        content: ""
      };
    },
    removeId() {
      this.fileId = false;
      this.file_url = "";
      this.fileIdForm = {
        name: "",
        extension: "",
        mimeType: "",
        content: ""
      };
    },
    remove() {
      window.location.href = "/workers";
    },
    signalChange: function(evt) {
      this.fileComproForm.name = evt.target.files[0].name;
      this.fileComproForm.mimeType = evt.target.files[0].type;
      this.fileComproForm.extension = evt.target.files[0].name.split(".")[1];
      this.file_url2 = URL.createObjectURL(evt.target.files[0]);
      this.file = true;
      var element = document.getElementById("formReceipt");
      element.classList.remove("form-csv-error");
      if (evt.target.files[0].type === "application/pdf") {
        let aux = this;
        var rdr = new FileReader();
        rdr.readAsDataURL(evt.target.files[0]);
        rdr.onload = function(e) {
          aux.fileComproForm.content = e.target.result.split(",")[1];
        };
      } else {
        let aux = this;
        var img = new Image();
        img.src = URL.createObjectURL(evt.target.files[0]);
        img.onload = function() {
          var rdr = new FileReader();
          rdr.onload = function(e) {
            aux.fileComproForm.content = e.target.result.split(",")[1];
          };
          rdr.readAsDataURL(evt.target.files[0]);
        };
      }
    },
    uploadId: function(evt) {
      this.fileIdForm.name = evt.target.files[0].name;
      this.fileIdForm.mimeType = evt.target.files[0].type;
      this.fileIdForm.extension = evt.target.files[0].name.split(".")[1];
      this.file_url = URL.createObjectURL(evt.target.files[0]);
      this.fileId = true;
      var element = document.getElementById("formId");
      element.classList.add("form-csv-error");
      if (evt.target.files[0].type === "application/pdf") {
        let aux = this;
        var rdr = new FileReader();
        rdr.readAsDataURL(evt.target.files[0]);
        rdr.onload = function(e) {
          aux.fileIdForm.content = e.target.result.split(",")[1];
        };
      } else {
        let aux = this;
        var img = new Image();
        img.src = URL.createObjectURL(evt.target.files[0]);
        img.onload = function() {
          var rdr = new FileReader();
          rdr.onload = function(e) {
            aux.fileIdForm.content = e.target.result.split(",")[1];
          };
          rdr.readAsDataURL(evt.target.files[0]);
        };
      }
    },
    toggleWorkers() {
      this.showImgW = !this.showImgW;
    },
    cropSuccess(imgDataUrl, field) {
      ///AVATAR IMAGE
      this.avatarImg = true;
      this.urlAvatar = imgDataUrl;
      this.profileFile = imgDataUrl.split(",")[1];
      this.extension2 = imgDataUrl.split(";")[0];
      var element = document.getElementById("avatar");
          element.classList.remove("form-csv-error2");
    },
     getOneContractor(){
      let aux = this;
      Axios.get(Servers.serverApi + "api/contractors/user", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
    }).then(function (response){
      
       aux.getConstructionsByContractor(response.data.uuid);

    }).catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    getConstructionsByContractor(uuid){
      let aux = this;
      Axios.get(Servers.serverApi + "api/constructions/contractor/?contractor="+uuid, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      }).then(function(response){
         for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].uuid,
              text: response.data[i].name
            };
            aux.constructions.push(temp);
          }

      }).catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });

    },
    getConstructions() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/constructions/", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].uuid,
              text: response.data[i].name
            };
            aux.constructions.push(temp);
          }
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    validateForm() {
      if (!this.constructionModel.value) {
        this.placeValid = true;
      }
      if (!this.fileId) {
        var element = document.getElementById("formId");
        element.classList.add("form-csv-error");
      }
      //valida que exista domicilio
      if (!this.file) {
        var element = document.getElementById("formReceipt");
        element.classList.add("form-csv-error");
      }

      if (!this.avatarImg) {
        var element = document.getElementById("avatar");
        element.classList.add("form-csv-error2");
      }
      if (
        this.file &&
        this.fileId &&
        this.constructionModel.value &&
        this.form.firstName != "" &&
        this.form.lastName != "" &&
        this.avatarImg
      ) {
        return true;
      } else {
        this.isLoading=false;
        return false;
      }
    },
    createWorkerAdmin(data) {
      let aux = this;
      Axios.post(
       Servers.serverApi + "api/constructionWorkers/administrator",
        data,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          aux.showMessageSucces("Trabajador creado correctamente");
          window.location.href = "/workers";
          aux.isLoading=false;
        })
        .catch(error => {
          console.log(error.response);
          aux.isLoading=false;
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    createWorkerContractor(data) {

       
    
      let aux = this;


      var newData = {
        construction: {
          uuid: data.construction.uuid
        },
        workers: [
          {
            firstName: data.firstName,
            lastName: data.lastName,
            identification: data.identification,
            photo: data.photo,
            proofOfAddress: data.proofOfAddress
          }
        ]
      };


      Axios.post(Servers.serverApi+ "api/constructionWorkerRequests", newData, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          //var auxMe = JSON.parse(localStorage.getItem('me'));
          // firebase.database().ref('workers/'+auxMe.idFrac+'/'+newData.construction.uuid+'/').push({
          //   worker: newData.workers[0].firstName+ ' '+ newData.workers[0].lastName
          // })
          aux.showMessageSucces("Solicitud de trabajador enviada");
          aux.isLoading=false;
          window.location.href = "/workers";
        })
        .catch(error => {
          console.log(error.response.data);
          aux.isLoading=false;
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    editWorkerAdmin(data) {
      let aux = this;
      Axios.put(
        Servers.serverApi +
          "api/constructionWorkers/" +
          this.$route.query.token +
          "/administrator",
        data,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          aux.showMessageSucces("¡Trabajador actualizado exitosamente!");
          aux.isLoading=false;
          window.location.href="/workers"
        })
        .catch(error => {
          console.log(error.response);
          aux.isLoading=false;
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    editWorkerContractor(data) {},
    checkFormWorker(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");

      this.isLoading=true;
      

      //valida que exista identificacion

      if (this.validateForm()) {
        if (this.$route.query.token != undefined) {
          //EDIT
          var data = {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            construction: {
              uuid: this.constructionModel.value
            },
            identification: {
              uuid: this.fileIdForm.name
            },
            photo: {
              uuid: this.fileAvatarForm.name
            },
            proofOfAddress: {
              uuid: this.fileComproForm.name
            }
          };

          if (this.profileFile != null) {
            var extensionFinal;
            var mimeTypeFinal;

            if (this.extension2 == "data:image/png") {
              extensionFinal = "png";
              mimeTypeFinal = "image/png";
            } else {
              extensionFinal = "jpg";
              mimeTypeFinal = "image/jpg";
            }
            var photo = {
              name: this.uuidv4(),
              extension: extensionFinal,
              mimeType: mimeTypeFinal,
              content: this.profileFile
            };
            data["photo"] = photo;
          }
          if (this.fileIdForm.content != "") {
            var identificacion = {
              name: this.fileIdForm.name,
              extension: this.fileIdForm.extension,
              mimeType: this.fileIdForm.mimeType,
              content: this.fileIdForm.content
            };
            data["identification"] = identificacion;
          }
          if (this.fileComproForm.content != "") {
            var comprobante = {
              name: this.fileComproForm.name,
              extension: this.fileComproForm.extension,
              mimeType: this.fileComproForm.mimeType,
              content: this.fileComproForm.content
            };
            data["proofOfAddress"] = comprobante;
          }

          let aux = this;
          if (localStorage.getItem("role") == "Contratista") {
            this.editWorkerContractor(data);
          } else {
            this.editWorkerAdmin(data);
          }
        } else {
          //Create

          var data = {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            construction: {
              uuid: this.constructionModel.value
            },
            identification: {
              name: this.fileIdForm.name,
              extension: this.fileIdForm.extension,
              mimeType: this.fileIdForm.mimeType,
              content: this.fileIdForm.content
            },
            photo: {},
            proofOfAddress: {
              name: this.fileComproForm.name,
              extension: this.fileComproForm.extension,
              mimeType: this.fileComproForm.mimeType,
              content: this.fileComproForm.content
            }
          };

          if (this.avatarImg) {
            var extensionFinal;
            var mimeTypeFinal;

            if (this.extension2 == "data:image/png") {
              extensionFinal = "png";
              mimeTypeFinal = "image/png";
            } else {
              extensionFinal = "jpg";
              mimeTypeFinal = "image/jpg";
            }
            var photo = {
              name: this.uuidv4(),
              extension: extensionFinal,
              mimeType: mimeTypeFinal,
              content: this.profileFile
            };
            data["photo"] = photo;
          }

          if (localStorage.getItem("role") == "Contratista") {
            this.createWorkerContractor(data);
          } else {
            this.createWorkerAdmin(data);
          }
        }
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl:
          Servers.serverImg + "apps/myfrac/admin/assets/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          //window.location.reload();
        }
      });
    },
    getOneWorker(uuid) {
      let aux = this;
      return Axios.get(this.urlServer + "api/constructionWorkers/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          aux.form.uuid = response.data.uuid;
          aux.form.firstName = response.data.firstName;
          aux.form.lastName = response.data.lastName;
          aux.constructionModel.value = response.data.construction.uuid;
          aux.constructionModel.text = response.data.construction.name;
          aux.placeValid = false;
          aux.file = true;
          aux.file_url2 = response.data.proofOfAddress.publicUrl;
          aux.fileId = true;
          aux.file_url = response.data.identification.publicUrl;
          aux.urlAvatar = response.data.photo.publicUrl;
          aux.avatarImg = true;
          aux.fileIdForm.name = response.data.identification.uuid;
          aux.fileComproForm.name = response.data.proofOfAddress.uuid;
          aux.fileAvatarForm.name = response.data.photo.uuid;
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    getOneConstruction(uuid) {
      let aux = this;
      this.isdisable = true;
      return Axios.get(this.urlServer + "api/constructions/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {

          aux.constructionModel.value = response.data.uuid;
          aux.constructionModel.text = response.data.name;
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    }
  },
  created() {
    if (localStorage.getItem("role") == "Contratista") {
           this.getOneContractor();
          } else {
            this.getConstructions();
          }
    
   
  },
  mounted() {
     var element = document.getElementById("formId");
    element.ondragover = function(event){
      event.preventDefault();
       var element2 = document.getElementById("formId");
       element2.classList.add("drag-over")
    }
    element.ondragleave = function(event){
      event.preventDefault();
      var element2 = document.getElementById("formId");
       element2.classList.remove("drag-over")
    }

        var element = document.getElementById("formReceipt");
    element.ondragover = function(event){
      event.preventDefault();
       var element2 = document.getElementById("formReceipt");
       element2.classList.add("drag-over")
    }
    element.ondragleave = function(event){
      event.preventDefault();
      var element2 = document.getElementById("formReceipt");
       element2.classList.remove("drag-over")
    }



    if (this.$route.query.token != undefined) {
      this.headerTitle = "Editar trabajador";
      this.buttonTitle = "Guardar";
      this.getOneWorker(this.$route.query.token);
    }
    if (this.$route.query.construction != undefined) {
      this.getOneConstruction(this.$route.query.construction);
    }
  },
  update() {},
  watch: {
    constructionModel(newConstr) {
      this.constructionModel = newConstr;
      if (newConstr.value || newConstr !== "") {
        this.placeValid = false;
      } else {
        this.placeValid = true;
      }
    },
    urlAvatar(newAavatar) {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.Datos-del-registro {
  width: auto;
  height: 19px;
  font-family: OpenSans-Bold;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.btn.btn-edit {
  padding: 0.2rem 0.4rem;
  font-size: 0.64rem;
  border-radius: 7px;
  width: 24px;
  height: 23p;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}
.form-csv-error {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid red !important;
  background-color: #ffffff;
}
.form-csv-error2 {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 3px solid red !important;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
 position: inherit;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 10rem;
    outline: none;
    opacity: 0;
    margin-bottom: -10rem;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

.Rectangle-536 {
  width: 190px;
  height: 37px;
  border-radius: 4px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-1673 {
  width: 161.6px !important;
  height: 37px !important;
  border-radius: 3px !important;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-650 {
  width: 1112.7px;
  height: 500.8px;
  border-radius: 25px;
  border: solid 2px #bce0fd;
  background-color: #ffffff;
}

.save-btn {
  font-size: 10px;
  float: right;
}

.text-width {
  width: auto;
}

.text-input {
  width: auto;
}

.btn-next {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-prev {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-final {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-color-next {
  background-color: #23a7ed !important;
  color: #fff !important;
}

.btn-color-prev {
  background-color: #ed5f5f !important;
  color: #fff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #d33 !important;
  font-size: 12px !important;
}

.btn-modal-download {
  height: 50% !important;
  width: auto !important;
  background-color: #a4a8ab !important;
  font-size: 12px !important;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}

.btn_background {
  background-color: #ed5f5f !important;
  object-fit: contain;
  width: 31.2px;
  margin-left: 25rem;
}

.btncapturar {
  width: 127px;
  height: 130px;
  object-fit: cover;
}

.style_avatar {
  margin-top: 0rem !important;
  /*margin-left: 3rem !important;*/
}
.drag-over{
  background-color: #ffffff;
  border: 4px dashed green;

}
</style>
